var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-col',{staticClass:"ml-0 pl-0 pl-5",attrs:{"lg":"3","md":"1","cols":"2","sm":"2"}},[_c('Logo')],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }